/**
 * Throws an error if the condition is not met
 * @param {any} condition The condition to test - if falsy, an error is thrown
 * @param {string|Error} failureMessage The error message that will be thrown.
 *   If it's a string, an new Error with this message is constructed and thrown
 *   If it's an Error, it just gets thrown
 */
export default function assert(condition, failureMessage = 'Assert condition failed') {
    if (!condition) {
        if (failureMessage instanceof Error)
            throw failureMessage;
        throw new Error(failureMessage);
    }
}
/**
 * Throws the first argument if it's an error
 * @param {Error} value The condition to test - if it's an Error (or subclass), throw it
 */
function ifError(value) {
    if (value instanceof Error)
        throw value;
}
assert.ifError = ifError;
//# sourceMappingURL=assert.js.map